import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Successfulprojects() {
  return (
    <section className="successful_projects ecommerce-app-case p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Successful <span>Real Estate App</span> Development Projects
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/solution/real-estate/homes-go-logo.webp"
                        alt="home-go"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={102}
                        height={100}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Simplifying Home Buying with Smart Search and Real-Time
                        Updates
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>faster discovery</p>
                      </div>
                      <div className="android_item">
                        <h5>34%</h5>
                        <p>higher satisfaction</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/projects"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/solution/real-estate/home-go-img.webp"
                      alt="home-go"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/solution/real-estate/estate-pie-logo.webp"
                        alt="home-go"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={102}
                        height={100}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Seamless Search and Real-Time Property Updates</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>41%</h5>
                        <p>quicker searches</p>
                      </div>
                      <div className="android_item">
                        <h5>35%</h5>
                        <p>more engagement</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/projects"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/solution/real-estate/estate-pie-img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/solution/real-estate/younit-logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={102}
                        height={100}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        A Property Search App for Effortless Browsing and
                        Instant Comparisons
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>38%</h5>
                        <p>faster comparisons</p>
                      </div>
                      <div className="android_item">
                        <h5>31%</h5>
                        <p>more inquiries</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/projects"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/solution/real-estate/younit-img.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successfulprojects;
